export function ErrorPage() {
  return (
    <>
      <h2 className="px-20 py-56">{`Página 404. Infelizmente não encontramos nenhuma página neste link :${`(`}`}</h2>
    </>
  );
}
